import React from 'react'
import { motion } from 'framer-motion'

import Image from '../../../assets/images/ddxpage/impact.webp'

const MedilearnImpact = () => {
  return (
    <section className="w-full">
      <div className="relative flex min-h-[180px] w-full items-center justify-center overflow-hidden md:min-h-[250px] lg:min-h-[250px] xl:min-h-[270px] 2xl:min-h-[350px]">
        {/* Background */}
        <img
          src={Image}
          alt="Final Note Background"
          className="absolute inset-0 h-full w-full object-cover"
        />

        {/* Content */}
        <div className="relative z-10 flex w-full max-w-[1600px] flex-col items-center justify-center px-6 text-center md:px-10">
          {/* Paragraphs */}
          <div className="mt-2 flex flex-col gap-4 text-center md:mt-6">
            <motion.p
              initial={{ opacity: 0, scale: 0.7 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, ease: 'easeOut' }}
              viewport={{ once: false }}
              className="font-gilroy-medium text-sm leading-[1.6] text-black/90 md:text-xl lg:text-2xl 2xl:text-3xl"
            >
              Medilearn redefines how users interact with healthcare
              information—making it accessible, engaging, and intelligent.{' '}
              <span className="font-gilroy-bold">
                accessible, engaging, and intelligent.
              </span>
            </motion.p>

            <motion.p
              initial={{ opacity: 0, scale: 0.7 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 0.8,
                delay: 0.2,
                ease: 'easeOut',
              }}
              viewport={{ once: false }}
              className="font-gilroy-medium text-sm leading-[1.6] text-black/90 md:text-xl lg:text-2xl 2xl:text-3xl"
            >
              The result is higher user trust, improved learning retention, and
              a significantly smoother health exploration journey.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MedilearnImpact